import ScoreCardContainer from './ScoreCardContainer';

export default ScoreCardContainer;
